module.exports = __webpack_public_path__ + "img/17-3.6da05a17.png";